import baseApi from "@/api/baseApi";

export default {
  getAll(context) {
    const mapping = {
      piglet: 'piglet',
      pigsty: 'pigSty'
    }

    if (typeof mapping[context.toLowerCase()] === 'undefined') {
      throw new Error('invalid context')
    }

    return baseApi.get(`/api-registration/v1/delivery-note?source=all&context=${mapping[context.toLowerCase()]}`)
  },

  get(id) {
    return baseApi.get(`/api-registration/v1/delivery-note/${id}`)
  },

  addOrUpdate(data) {
    return baseApi.post(`/api-registration/v1/delivery-note`, data)
  },
}
